import { Theme, useTheme } from "@/components/theme/themeProvider"
import Vector from "@images/background/vector.svg"
import { BoxOnboardingWrapper } from "@modules/box/components/boxOnboardingWrapper"
import { BoxOnboardingStripeFirstPage } from "@modules/box/page/boxOnboardingStripeFirstPage"
import { BoxOnboardingStripeSecondPage } from "@modules/box/page/boxOnboardingStripeSecondPage"
import { word } from "@modules/core/utils/i18n"
import { useBoxNavigate } from "@modules/navigation/hooks/useBoxNavigate"
import { Path } from "@modules/navigation/routes"
import { useConfirmPopup } from "@modules/ui/components/popup/huConfirmPopup"
import { useState } from "react"
import { useNavigate } from "react-router"

/**
 * This page is used for Stripe onboarding
 * so that the owners can create their Stripe account
 * @returns {React.ReactNode} - Wrapper & Header & BoxOnboardingStripeFirstPage | BoxOnboardingStripeSecondPage
 */
export const BoxOnboardingStripe: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<0 | 1>(0)

  const { setTheme } = useTheme()
  const navigate = useNavigate()
  const boxNavigate = useBoxNavigate()

  const popup = useConfirmPopup()

  const handleClose = () =>
    popup.show({
      title: word("box.stripe.onboarding.cancel.title"),
      message: word("box.stripe.onboarding.cancel.description"),
      accept: () => {
        setTheme(Theme.AthleteLight)
        setTimeout(() => navigate(Path.Root), 100)
      },
    })

  const handleButtonNavigation = (nextPage: 0 | 1) => {
    setCurrentPage(nextPage)
  }

  const handleButtonTryLiteVersion = () => {
    boxNavigate(Path.Box.LiteVersion)
  }

  return (
    <BoxOnboardingWrapper backgroundImage={Vector} handleClose={handleClose}>
      {currentPage === 0 ? (
        <BoxOnboardingStripeFirstPage
          handleNextPageNavigation={() => handleButtonNavigation(1)}
          handleButtonTryLiteVersion={handleButtonTryLiteVersion}
        />
      ) : (
        <BoxOnboardingStripeSecondPage handlePreviousPageNavigation={() => handleButtonNavigation(0)} />
      )}
    </BoxOnboardingWrapper>
  )
}
